import * as tslib_1 from "tslib";
import { Component, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import * as ɵngcc0 from '@angular/core';
let RawComponent = class RawComponent {
    constructor(renderer, elementRef) {
        this.renderer = renderer;
        this.elementRef = elementRef;
    }
    ngOnInit() {
        const el = this.renderer.createElement(this.rendering.name);
        const contents = this.renderer.createText(this.rendering.contents || '');
        const attributes = this.rendering.attributes;
        for (const attr in attributes) {
            if (attributes.hasOwnProperty(attr)) {
                const value = attributes[attr];
                this.renderer.setAttribute(el, attr, value || '');
            }
        }
        this.renderer.appendChild(el, contents);
        const parentNode = this.renderer.parentNode(this.elementRef.nativeElement);
        this.renderer.insertBefore(parentNode, el, this.elementRef.nativeElement);
        parentNode.removeChild(this.elementRef.nativeElement);
    }
};
RawComponent.ɵfac = function RawComponent_Factory(t) { return new (t || RawComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
RawComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: RawComponent, selectors: [["sc-raw"]], inputs: { rendering: "rendering" }, decls: 0, vars: 0, template: function RawComponent_Template(rf, ctx) { }, encapsulation: 2 });
RawComponent.ctorParameters = () => [
    { type: Renderer2 },
    { type: ElementRef }
];
tslib_1.__decorate([
    Input()
], RawComponent.prototype, "rendering", void 0);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RawComponent, [{
        type: Component,
        args: [{
                selector: 'sc-raw',
                template: ``
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }]; }, { rendering: [{
            type: Input
        }] }); })();
export { RawComponent };
